import { instrumentsConfig } from "shared/games/instruments/instrumentsConfig";
import Instrument from "shared/games/instruments/Instrument";

export default function prettyInstrument(
  instrument: Instrument,
  short = false
) {
  if (short) {
    return instrumentsConfig[instrument].shortName;
  }

  return instrumentsConfig[instrument].name;
}
